import "../CSS/profile.css";
import Swal from "sweetalert2";
import { onSignInSubmit, verifyOTP, checkPhoneNumberAccounts } from "../../api/accounts";
import { checkPhoneNumberRequests } from "../../api/requests";

const swalWithBootstrapButtons = Swal.mixin({
  customClass: {
    confirmButton: "btn btn-primary mr-2",
    cancelButton: "btn btn-danger ml-2",
  },
  buttonsStyling: false,
});

export default function otpHelper(contact: string, values: any, 
  setSubmitting: Function, request: boolean, organization: boolean, sameNumber: boolean, successFunction: Function) {
  if (organization) {
    successFunction();
  } else {
    if (request) {
      checkPhoneNumberRequests(contact).then((value) => {
        if (value) {
          swalWithBootstrapButtons.fire({
            icon: "warning",
            title: "A request already exists on the given number.",
            text:
              "You can only make one request per mobile number. To make more requests, make an organization account.",
            footer: "Thankyou. Stay Safe.",
          });
          setSubmitting(false);
        } else {
          onSignInSubmit("+" + contact);
        swalWithBootstrapButtons
          .fire({
            icon: "info",
            title: "Enter OTP Code",
            text: "Enter the OTP code you recieved on the number provided.",
            input: "text",
            inputPlaceholder: "Enter OTP here",
            showCancelButton: true,
            cancelButtonText: "Resend OTP",
            showCloseButton: true,
            footer:
              "<strong>If you accidently entered wrong phone number, hit resend code.</strong>",
          })
          .then(async (result: any) => {
            if (result.value) {
              if (await verifyOTP(result.value)) {
                successFunction();
              } else {
                swalWithBootstrapButtons.fire({
                  icon: "error",
                  title: "Error",
                  text: "Invalid OTP entered!",
                  footer: "<strong>Try again</strong>",
                });
                setSubmitting(false);
              }
            } else if (result.dismiss === Swal.DismissReason.cancel) {
              swalWithBootstrapButtons
                .fire({
                  icon: "info",
                  title: "Send Code on this Number?",
                  text: "If you want to change the number, change now.",
                  input: "text",
                  inputValue: `${values.contact}`,
                  showCancelButton: true,
                  footer:
                    "<strong>Enter the number you want to use, the OTP code will be sent there.</strong>",
                })
                .then((result: any) => {
                  if (result.value) {
                    if (typeof result.value === "string") {
                      // onSignInSubmit(`+92${result.value.substr(1)}`);
                      contact = `92${result.value.substr(1)}`;
                      values.contact = result.value;
                      setSubmitting(false);
                      swalWithBootstrapButtons.fire({
                        icon: "info",
                        title: "OTP Will Be Sent",
                        text: "A code will be sent on the number provided!",
                        footer: "<strong></strong>",
                      }).then(() => {
                        otpHelper(contact, values, setSubmitting, request, organization, sameNumber, successFunction);
                      });
                    } else {
                      swalWithBootstrapButtons.fire({
                        icon: "error",
                        title: "Error",
                        text: "Invalid number Entered!",
                        footer: "<strong>Try again</strong>",
                      });
                      setSubmitting(false);
                    }
                  }
                });
            } else if (result.dismiss === Swal.DismissReason.close) {
              setSubmitting(false);
            }
          });
        }
      })
    } else {
      if (sameNumber) {
        successFunction();
      } else {
        checkPhoneNumberAccounts(contact).then((value) => {
          if (value) {
            swalWithBootstrapButtons.fire({
              icon: "warning",
              title: "User already exists on the given number.",
              text: "You can only make one account per mobile number. To make more accounts, register with a new number.",
              footer: "Thank you. Stay Safe.",
            });
            setSubmitting(false);
          } else {
            onSignInSubmit("+" + contact);
          swalWithBootstrapButtons
            .fire({
              icon: "info",
              title: "Enter OTP Code",
              text: "Enter the OTP code you recieved on the number provided.",
              input: "text",
              inputPlaceholder: "Enter OTP here",
              showCancelButton: true,
              cancelButtonText: "Resend OTP",
              showCloseButton: true,
              footer:
                "<strong>If you accidently entered wrong phone number, hit resend code.</strong>",
            })
            .then(async (result: any) => {
              if (result.value) {
                if (await verifyOTP(result.value)) {
                  successFunction();
                } else {
                  swalWithBootstrapButtons.fire({
                    icon: "error",
                    title: "Error",
                    text: "Invalid OTP entered!",
                    footer: "<strong>Try again</strong>",
                  });
                  setSubmitting(false);
                }
              } else if (result.dismiss === Swal.DismissReason.cancel) {
                swalWithBootstrapButtons
                  .fire({
                    icon: "info",
                    title: "Send Code on this Number?",
                    text: "If you want to change the number, change now.",
                    input: "text",
                    inputValue: `${values.contact}`,
                    showCancelButton: true,
                    footer:
                      "<strong>Enter the number you want to use, the OTP code will be sent there.</strong>",
                  })
                  .then((result: any) => {
                    if (result.value) {
                      if (typeof result.value === "string") {
                        // onSignInSubmit(`+92${result.value.substr(1)}`);
                        contact = `92${result.value.substr(1)}`;
                        values.contact = result.value;
                        setSubmitting(false);
                        swalWithBootstrapButtons.fire({
                          icon: "info",
                          title: "OTP Sent",
                          text: "A code will be sent on the number provided!",
                          footer: "<strong></strong>",
                        }).then(() => {
                          otpHelper(contact, values, setSubmitting, request, organization, sameNumber, successFunction);
                        });
                      } else {
                        swalWithBootstrapButtons.fire({
                          icon: "error",
                          title: "Error",
                          text: "Invalid number Entered!",
                          footer: "<strong>Try again</strong>",
                        });
                        setSubmitting(false);
                      }
                    }
                  });
              } else if (result.dismiss === Swal.DismissReason.close) {
                setSubmitting(false);
              }
            });
          }
        });
      }
    }
    // checkPhoneNumberRequests(contact).then((value) => {
    //   if (request && value) {
    //     swalWithBootstrapButtons.fire({
    //       icon: "warning",
    //       title: "A request already exists on the given number.",
    //       text:
    //         "You can only make one request per mobile number. To make more requests, make an organization account.",
    //       footer: "Thankyou. Stay Safe.",
    //     });
    //     setSubmitting(false);
    //   }
    //   else if (value) {
    //     swalWithBootstrapButtons.fire({
    //       icon: "warning",
    //       title: "User already exists on the given number.",
    //       text: "You can only make one account per mobile number. To make more accounts, register with a new number.",
    //       footer: "Thank you. Stay Safe.",
    //     });
    //     setSubmitting(false);
    //   } else if (!sameNumber) {
    //     onSignInSubmit("+" + contact);
    //     swalWithBootstrapButtons
    //       .fire({
    //         icon: "info",
    //         title: "Enter OTP Code",
    //         text: "Enter the OTP code you recieved on the number provided.",
    //         input: "text",
    //         inputPlaceholder: "Enter OTP here",
    //         showCancelButton: true,
    //         cancelButtonText: "Resend OTP",
    //         showCloseButton: true,
    //         footer:
    //           "<strong>If you accidently entered wrong phone number, hit resend code.</strong>",
    //       })
    //       .then(async (result: any) => {
    //         if (result.value) {
    //           if (await verifyOTP(result.value)) {
    //             successFunction();
    //           } else {
    //             swalWithBootstrapButtons.fire({
    //               icon: "error",
    //               title: "Error",
    //               text: "Invalid OTP entered!",
    //               footer: "<strong>Try again</strong>",
    //             });
    //             setSubmitting(false);
    //           }
    //         } else if (result.dismiss === Swal.DismissReason.cancel) {
    //           swalWithBootstrapButtons
    //             .fire({
    //               icon: "info",
    //               title: "Send Code on this Number?",
    //               text: "If you want to change the number, change now.",
    //               input: "text",
    //               inputValue: `${values.contact}`,
    //               showCancelButton: true,
    //               footer:
    //                 "<strong>Enter the number you want to use, the OTP code will be sent there.</strong>",
    //             })
    //             .then((result: any) => {
    //               if (result.value) {
    //                 if (typeof result.value === "string") {
    //                   // onSignInSubmit(`+92${result.value.substr(1)}`);
    //                   values.contact = result.value;
    //                   setSubmitting(false);
    //                   swalWithBootstrapButtons.fire({
    //                     icon: "info",
    //                     title: "OTP Sent",
    //                     text: "A code is sent on the number provided!",
    //                     footer: "<strong></strong>",
    //                   }).then(() => {
    //                     otpHelper(contact, values, setSubmitting, false, false, sameNumber, successFunction);
    //                   });
    //                 } else {
    //                   swalWithBootstrapButtons.fire({
    //                     icon: "error",
    //                     title: "Error",
    //                     text: "Invalid number Entered!",
    //                     footer: "<strong>Try again</strong>",
    //                   });
    //                   setSubmitting(false);
    //                 }
    //               }
    //             });
    //         } else if (result.dismiss === Swal.DismissReason.close) {
    //           setSubmitting(false);
    //         }
    //       });
    //   } else {
    //     successFunction();
    //   }
    // });
  }
}